import { Component } from '@angular/core';

@Component({
  selector: 'itr-loader',
  templateUrl: './itr-loader.component.html',
  styleUrls: ['./itr-loader.component.scss']
})
export class ItrLoaderComponent {}
